import React, { useEffect, useState } from 'react';
import { X, Cookie } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    t,
    language
  } = useLanguage();
  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after 1 second delay
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    // Enable analytics
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;
      (window as any).gtag('consent', 'update', {
        analytics_storage: 'granted'
      });
    }
  };
  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };
  if (!isVisible) return null;
  const content = {
    en: {
      title: 'Cookie Consent',
      message: 'We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking "Accept", you consent to our use of cookies.',
      accept: 'Accept',
      decline: 'Decline',
      privacy: 'Privacy Policy'
    },
    id: {
      title: 'Persetujuan Cookie',
      message: 'Kami menggunakan cookie untuk meningkatkan pengalaman browsing Anda, menganalisis lalu lintas situs, dan mempersonalisasi konten. Dengan mengklik "Terima", Anda menyetujui penggunaan cookie kami.',
      accept: 'Terima',
      decline: 'Tolak',
      privacy: 'Kebijakan Privasi'
    }
  };
  const text = content[language];
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-slide-up" data-id="element-45">
      <div className="max-w-6xl mx-auto bg-carbon border border-white/20 rounded-lg shadow-2xl backdrop-blur-md" data-id="element-46">
        <div className="p-6 md:p-8" data-id="element-47">
          <div className="flex items-start justify-between mb-4" data-id="element-48">
            <div className="flex items-center" data-id="element-49">
              <Cookie className="w-6 h-6 text-ai-teal mr-3 flex-shrink-0" data-id="element-50" />
              <h3 className="text-lg font-display font-bold text-ivory" data-id="element-51">
                {text.title}
              </h3>
            </div>
            <button onClick={handleDecline} className="text-gray-400 hover:text-white transition-colors p-1" aria-label="Close" data-id="element-52">
              <X className="w-5 h-5" data-id="element-53" />
            </button>
          </div>

          <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-54">
            {text.message}
          </p>

          <div className="flex flex-col sm:flex-row gap-3" data-id="element-55">
            <button onClick={handleAccept} className="px-6 py-3 bg-ai-teal text-carbon font-bold text-sm uppercase tracking-widest hover:bg-ai-teal/90 transition-colors" data-id="element-56">
              {text.accept}
            </button>
            <button onClick={handleDecline} className="px-6 py-3 border border-white/20 text-ivory font-bold text-sm uppercase tracking-widest hover:bg-white/5 transition-colors" data-id="element-57">
              {text.decline}
            </button>
            <a href="/privacy" className="px-6 py-3 text-gray-400 hover:text-ai-teal font-mono text-xs uppercase tracking-widest transition-colors flex items-center justify-center" data-id="element-58">
              {text.privacy}
            </a>
          </div>
        </div>
      </div>
    </div>;
}